"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Email = exports.IsoDateString = exports.NonEmptyString = exports.NumericString = exports.PositiveNonZeroInteger = exports.PositiveOrZeroInteger = exports.Integer = undefined;

var _tcombValidation = require("tcomb-validation");

var _tcombValidation2 = _interopRequireDefault(_tcombValidation);

var _lodash = require("lodash");

var _joi = require("joi");

var Joi = _interopRequireWildcard(_joi);

var _types = require("../../backend/src/shared/schemas/types");

var joiTypes = _interopRequireWildcard(_types);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// these constrained types are used for the model validations, or directly within the reducer state schemas
var Integer = exports.Integer = _tcombValidation2.default.subtype(_tcombValidation2.default.Number, function (val) {
    return (0, _lodash.isFinite)(val) && val % 1 === 0;
});
var PositiveOrZeroInteger = exports.PositiveOrZeroInteger = _tcombValidation2.default.subtype(_tcombValidation2.default.Number, function (val) {
    return val > 0 && (0, _lodash.isFinite)(val) && val % 1 === 0 || val === 0;
});
var PositiveNonZeroInteger = exports.PositiveNonZeroInteger = _tcombValidation2.default.subtype(_tcombValidation2.default.Number, function (val) {
    return val > 0 && (0, _lodash.isFinite)(val) && val % 1 === 0;
});
var NumericString = exports.NumericString = _tcombValidation2.default.subtype(_tcombValidation2.default.String, function (val) {
    return (0, _lodash.isFinite)((0, _lodash.parseInt)(val)) === true;
});
var NonEmptyString = exports.NonEmptyString = _tcombValidation2.default.subtype(_tcombValidation2.default.String, function (val) {
    return (0, _lodash.trim)(val).length > 0;
});
var IsoDateString = exports.IsoDateString = _tcombValidation2.default.subtype(_tcombValidation2.default.String, function (val) {
    return (0, _moment2.default)(val).isValid() === true;
});
var Email = exports.Email = _tcombValidation2.default.subtype(_tcombValidation2.default.String, function (val) {
    try {
        var validationResult = Joi.validate(val, joiTypes.email.required()); // reuse joi type validation.
        return validationResult.error ? false : true;
    } catch (e) {
        return false;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/types.ts
 ** module id = 1315
 ** module chunks = 0
 **/